export const configes = {
    domainName: "WeBuyAnyLHDCars",
    domainURL: "webuyanylhdcars.com",
    domainId: "677e1082a287ec34fe5cff61",
  };